<script>
	import { nextTick } from "vue";
	// #ifdef APP-PLUS
	// import { useShanYanStore } from "@/stores/shanYan.js"
	import { useSocketStore } from "@/stores/socket.js"
	// #endif
	// #ifdef H5
	import { mountLetterPopup } from "@/utils/mountLetterPopup.js"
	// #endif
	import { useAppUpdateStore, useMiniUpdate, useSystemStore } from "@/stores/system.js"
	import { useUserStore } from "@/stores/user.js"
	import { useBusinessMallStore } from "@/stores/businessMall.js"
	import useHandlerEvent from "@/hook/useHandlerEvent.js"
	import { useI18n } from 'vue-i18n'
	export default {
		globalData:{
			orderSubmitInfo: null
		},
		// // #ifdef H5
		// watch:{
		// 	"$route": (route) => {
		// 		const BMStore = useBusinessMallStore();
		// 		if(BMStore.isStorePlatform){
		// 			if(route.path === '/'){
		// 				setTimeout(() => {
		// 					uni.reLaunch({
		// 						url: '/pages/Mall/Store'
		// 					})
		// 				},100);
		// 			}
		// 		}
		// 	}
		// },
		// // #endif
		onLaunch: async function() {
			console.log('App Launch');
			// #ifdef H5
			// 站内信实时通知弹窗：挂到 body，脱离具体页面，任意页面均可弹出
			mountLetterPopup();
			// #endif
			const userStore = useUserStore();
			const systemStore = useSystemStore();
			const { locale } = useI18n()
			locale.value = systemStore.getFrontendLanguageKey(locale.value);
			uni.setStorageSync('language',locale.value)
			systemStore.getLanguageList();
			
			// #ifdef APP-PLUS
				//闪验初始化
				// const shanYan = useShanYanStore();
				// shanYan.onInit();
				//APP检测更新
				const appStore = useAppUpdateStore();
				appStore.onCheckForUpdate();
				//引导页
				// if(!uni.getStorageSync('guideFlag')){
				// 	// uni.reLaunch({
				// 	// 	url: '/pages/Guide/Index'
				// 	// })
				// 	// setTimeout(() => {
				// 	// 	plus.navigator.closeSplashscreen();
				// 	// },1000)
				// }else{
					// plus.navigator.closeSplashscreen();
				// }
			// #endif
			
			// 初始化登录
			try{
				let hasLogin = false;
				if(userStore.token){
					hasLogin = true;
				}else{
					// #ifdef MP-WEIXIN
						const res = await userStore.onMinWxLogin();
						hasLogin = res.body.isBind == 1;
					// #endif
				}
				// userStore.hasLogin = hasLogin;
				if(hasLogin){
					await userStore.onGetUserInfo();
					await userStore.onGetShopCartNum();
				}
			}catch(e){
				console.log('启动', e)
			}
		},
		onShow: function(e) {
			console.log('App Show')
			
			// #ifdef APP-PLUS
				//连接 socket
				// const socketStore = useSocketStore();
				// socketStore.onInit();
			// #endif
			
			// #ifdef MP-WEIXIN
				const { handlerQrCodeParsing } = useHandlerEvent();
				const miniUpdateStore = useMiniUpdate();
				
				//场景
				switch(e.scene){
					case 1011: //扫描二维码
					case 1012: //长按图片识别二维码
					case 1013: //扫描手机相册中选取的二维码
						console.log(e.query)
						handlerQrCodeParsing(e.query.q)
					break;
				}
				
				//分享
				if(e.query.inviteCode){
					this.$utils.storage.set('inviteCode', e.query.inviteCode);
				}
				
				//小程序码
				if(e.query.scene){
					let inviteCode = decodeURIComponent(e.query.scene);
					const params = inviteCode.split('=');
					this.$utils.storage.set('inviteCode', params[1]);
				}
				
				//更新
				miniUpdateStore.onUpdate();
			// #endif
		},
		onHide: function() {
			console.log('App Hide')
		}
	}
</script>

<style lang="scss">
	/*每个页面公共css */
	/* #ifndef APP-NVUE */
	@import "@/styles/index.scss";
	:deep(#_root){
		._img{
			display: block !important;
		}
	}
	/* #endif */
	@import url('https://fonts.googleapis.com/css2?family=Alimama+ShuHeiTi&display=swap');
</style>
